import { NEW_ALERTS_INVENTORY_TIME_RANGE_PARAMS } from '../../alerts/overview/alertsInventoryUrlParams';

class DimensionsService {
    constructor(featureEnabled) {
        this.featureEnabled = featureEnabled;
    }

    getForPlots(plots = [], orgId) {
        return this._getUniqueDimensions(plots).map((dimension) => ({
            propertyName: dimension.key,
            propertyValue: dimension.value,
            url: this._getDataLinkUrl(dimension, orgId),
        }));
    }

    _getUniqueDimensions(plots) {
        const dimensions = plots
            .filter((plot) => !!plot.key)
            .flatMap((plot) => this._getPlotDimensions(plot));
        return _.uniqWith(dimensions, _.isEqual);
    }

    _getPlotDimensions(plot) {
        return Object.entries(plot.key)
            .map(([key, value]) => ({ key, value }))
            .filter((obj) => obj.key !== 'sf_metric');
    }

    _getDataLinkUrl({ key, value }, orgId) {
        if (this.featureEnabled && this.featureEnabled('newAlertsInventoryPage')) {
            if (key === 'sf_severity') {
                return `#/alerts?severity=${encodeURIComponent(
                    value
                )}&${NEW_ALERTS_INVENTORY_TIME_RANGE_PARAMS}`;
            }
            return `#/alerts?customProperties=${encodeURIComponent(key)}:${encodeURIComponent(
                value
            )}&${NEW_ALERTS_INVENTORY_TIME_RANGE_PARAMS}`;
        }
        return `#/alerts/${orgId}?sources[]=${encodeURIComponent(key)}:${encodeURIComponent(
            value
        )}`;
    }
}

export default DimensionsService;
